/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Knp_Guide_Restricted_Access_TextInputs */

const en_knp_guide_restricted_access_text = /** @type {(inputs: Knp_Guide_Restricted_Access_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Limited to ${i?.count} group(s).`)
};

const fr_knp_guide_restricted_access_text = /** @type {(inputs: Knp_Guide_Restricted_Access_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Limité à ${i?.count} groupe(s).`)
};

const de_knp_guide_restricted_access_text = /** @type {(inputs: Knp_Guide_Restricted_Access_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Beschränkt auf die Gruppe(n) ${i?.count}.`)
};

const it_knp_guide_restricted_access_text = /** @type {(inputs: Knp_Guide_Restricted_Access_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Limitato a ${i?.count} gruppi.`)
};

const ru_knp_guide_restricted_access_text = /** @type {(inputs: Knp_Guide_Restricted_Access_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ограничено группой(ами) ${i?.count}.`)
};

const es_knp_guide_restricted_access_text = /** @type {(inputs: Knp_Guide_Restricted_Access_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Limitado a ${i?.count} grupo(s).`)
};

const zh_cn2_knp_guide_restricted_access_text = /** @type {(inputs: Knp_Guide_Restricted_Access_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`仅限 ${i?.count} 组。`)
};

const ja_knp_guide_restricted_access_text = /** @type {(inputs: Knp_Guide_Restricted_Access_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} グループに限定されます。`)
};

const hi_knp_guide_restricted_access_text = /** @type {(inputs: Knp_Guide_Restricted_Access_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`केवल ${i?.count} समूह(समूहों) तक सीमित।`)
};

const pt_pt2_knp_guide_restricted_access_text = /** @type {(inputs: Knp_Guide_Restricted_Access_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Limitado ao(s) grupo(s) ${i?.count}.`)
};

/**
* | output |
* | --- |
* | "Limited to {count} group(s)." |
*
* @param {Knp_Guide_Restricted_Access_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_guide_restricted_access_text = /** @type {((inputs: Knp_Guide_Restricted_Access_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Guide_Restricted_Access_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_guide_restricted_access_text(inputs)
	if (locale === "de") return de_knp_guide_restricted_access_text(inputs)
	if (locale === "it") return it_knp_guide_restricted_access_text(inputs)
	if (locale === "ru") return ru_knp_guide_restricted_access_text(inputs)
	if (locale === "es") return es_knp_guide_restricted_access_text(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_guide_restricted_access_text(inputs)
	if (locale === "ja") return ja_knp_guide_restricted_access_text(inputs)
	if (locale === "hi") return hi_knp_guide_restricted_access_text(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_guide_restricted_access_text(inputs)
	return en_knp_guide_restricted_access_text(inputs)
});